import { NeoModel, ValueObject } from "@singularsystems/neo-core";
import ManuallyCreatedTransactionLookup from "../Lookups/ManuallyCreatedTransactionLookup";

@NeoModel
export default class SaveManualTransactionCommand extends ValueObject {
    
    public manuallyCreatedTransactionLookups: ManuallyCreatedTransactionLookup[] = [];

    public userName: string | undefined = "";
}